import { render, staticRenderFns } from "./RunHistory.vue?vue&type=template&id=3006f7cf&"
import script from "./RunHistory.vue?vue&type=script&lang=js&"
export * from "./RunHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports